var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { class: { "d-none": _vm.activeTab !== "main" } }, [
      _c("h4", [_vm._v("Regions Main page")]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }